import type {UserVO} from '@Utils/user.util';
import type {ButtonType} from '@Components/button';

export interface NotificationsPanelProps {
  isMobile: boolean;
  className?: string;
  onClosePanel?: VoidFunction;
}

export enum NotificationsPanelDisplayType {
  LOADING = 1,
  EMPTY = 2,
  LOADED = 3,
  SETTINGS = 4,
  TURN_ON_NOTIFICATIONS = 5,
}

export enum NotificationIconType {
  SUCCESS = 1,
  DANGER = 2,
  AI = 3,
  PRIMARY = 4,
  SECONDARY = 5,
  NEUTRAL = 6,
  WARNING = 7,
}

export enum NotificationCategory {
  EVENTS = 1,
  FOLDER = 2,
  BUSINESSPROFILE = 3,
  MAILING_LIST = 4,
  SM_PUBLISHING = 5,
  DESIGNERS = 6,
  POSTER = 7,
  BRANDS = 8,
  COLLABORATION = 9,
  MARKETING = 10,
}

export enum NotificationStatus {
  READ = 1,
  SEEN = 2,
  NEW = 3,
}

export interface NotificationAJAXResponse {
  new: Notification[];
  today: Notification[];
  yesterday: Notification[];
  others: Notification[];
  notificationSettings: NotificationSettingsPanelData;
  newNotificationsCount: number;
}

export interface NotificationUpdateDispatchType {
  today: Notification[];
  yesterday: Notification[];
  others: Notification[];
}

export interface Notification {
  idnotification: number;
  iduser: number;
  hashedId: string;
  status: NotificationStatus;
  notificationCategory: NotificationCategory;
  notificationAction: NotificationAction;
  createdOn: number;
  readOn: string | null;
  itemId: string;
  itemData: string;
}
export enum NotificationApprovalStatus {
  APPROVED = 1,
  DECLINED = 2,
  PENDING = 3,
  NOT_REQUIRED = 4,
}
export interface NotificationsItemData {
  sharedBy: UserVO[];
  redirectionLink: string;
  imageUrl?: string;
  comment?: string;
  approvalStatus?: NotificationApprovalStatus;
  totalUsers?: number;

  notificationMiniIcon?: string;
  notificationMiniIconType?: NotificationIconType;
  notificationIcon?: string;
  notificationTitle?: string;
  allowAggregation?: boolean;
  aggregationText?: string;
  aggregationRedirectionLink?: string | null;
  buttons?: NotificationsCTA[];
}

export interface NotificationsCTA {
  text: string;
  icon?: string | null;
  type?: ButtonType | null;
  link?: string | null;
  ajaxUri?: string | null;
  textAfterSuccess?: string | null;
  approvalValue?: NotificationApprovalStatus | null;
  iconForTextAfterSuccess?: string | null;
  /** Opts the label out of the button's sentence-case lowercasing (a proper noun or an acronym in the label). */
  hasProperNoun?: boolean | null;
}

export interface NotificationsPanelReduxState {
  newNotifications: Notification[];
  todaysNotifications: Notification[];
  yesterdaysNotifications: Notification[];
  otherNotifications: Notification[];
  panelDisplayType: NotificationsPanelDisplayType;
  notificationSettings: NotificationSettingsPanelData;
  allNotifications: Notification[];
  previousNotificationSettings: NotificationSettingsPanelData;
  startFetchingNotifications: boolean;
  loadMore: boolean;
  newNotificationsCount: number;
}

export interface NotificationSettingsPanelData {
  designUpdates: boolean;
  teamUpdates: boolean;
  emailCampaigns: boolean;
  socialMediaPosts: boolean;
  eventsUpdates: boolean;
}

export interface MiniIconStyles {
  className: string;
  hoverClassName: string;
}

export enum NotificationAction {
  COLLABORATOR = 'COLLABORATOR',
  COMMENT = 'COMMENT',
  TEAM_SHARE = 'TEAM_SHARE',
  REQUEST_EDIT_ACCESS = 'REQUEST_EDIT_ACCESS',
  ACCEPT_EDIT_ACCESS = 'ACCEPT_EDIT_ACCESS',
  STATISTICS = 'STATISTICS',
  REGISTRATION = 'REGISTRATION',
  LOW_REPUTATION = 'LOW_REPUTATION',
  PUBLISHED = 'PUBLISHED',
  ERROR_PUBLISHING = 'ERROR_PUBLISHING',
  SCHEDULED = 'SCHEDULED',
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  LIMIT_HIT = 'LIMIT_HIT',
  TEAM_INVITE = 'TEAM_INVITE',
  REJECTION = 'REJECTION',

  COLLABORATOR_ADDED = 'COLLABORATOR_ADDED',
  RESEND_INVITE = 'RESEND_INVITE',

  REMINDERS = 'REMINDERS',
  MARKETING = 'MARKETING',
  TICKETING_SOLD_OUT = 'TICKETING_SOLD_OUT',
  TICKETING_PLAN_LIMIT_APPROACHING = 'TICKETING_PLAN_LIMIT_APPROACHING',
  TICKETING_PLAN_LIMIT_REACHED = 'TICKETING_PLAN_LIMIT_REACHED',
  TICKETING_REFUND_PROCESSED = 'TICKETING_REFUND_PROCESSED',
  TICKETING_REFUND_APPROVAL = 'TICKETING_REFUND_APPROVAL',
  TICKETING_REGISTRATIONS_CLOSED = 'TICKETING_REGISTRATIONS_CLOSED',
  TICKETING_PAYOUT_RELEASED = 'TICKETING_PAYOUT_RELEASED',
  TICKETING_PAYOUT_ON_HOLD = 'TICKETING_PAYOUT_ON_HOLD',
  TICKETING_STRIPE_ONBOARDING = 'TICKETING_STRIPE_ONBOARDING',
  TICKETING_SALES_PAUSED = 'TICKETING_SALES_PAUSED',
  TICKETING_DAILY_SALES = 'TICKETING_DAILY_SALES',
}
